import PropTypes from 'prop-types';
import React from 'react';


export default function PillStatus(props:any) {

    const onClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        if (props.onClick) props.onClick(props.value)
    }

    const onDelete = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        if (props.onDelete) props.onDelete(props.value)
    }

    const status = gd.session.statuses.get(props.statusId)

    const bgClass = 'bg-status-paleBg-'+status.color
    const txtClass = 'ui5-txt-status-'+status.color

    const classes = Classes(
        'ui5-pill-u', 'pale',
        bgClass, txtClass,
        's-'+props.size,
        props.className
    );

    return (
        <div className={classes} onClick={onClick}>
            <div className="pill-label">{status.name}</div>
            {props.onDelete && <div className="i5-close" onClick={onDelete} />}
        </div>
    )
}


PillStatus.propTypes = {
    size        : PropTypes.oneOf([26, 22]),

    // callbacks
    onClick     : PropTypes.func,
    onDelete    : PropTypes.func,       // if set adds delete button
    value       : PropTypes.any,       // this is what being passed when we set on click or on delete !!!

    className   : PropTypes.any,
    style       : PropTypes.any,

    // Special cases
    statusId    : PropTypes.string.isRequired,     // if passes - display icon & label automatically
}

PillStatus.defaultProps = {
    size        : '26'
}
